import React, { useState } from "react";
import { Container, Form, Button, Row, Col, NavLink } from "react-bootstrap";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Password } from "primereact/password";
import { useDispatch } from "react-redux";
import "../Pages/LoginPage.css";
import { useNavigate } from "react-router-dom";
import { loginUser } from "../Redux/Actions.tsx";
import { AppDispatch } from "../Redux/Store/index.ts";
import { useAlert } from "../Components/Alert.tsx";
import PasswordDimenticata from "../Components/PasswordDimenticata.tsx";

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const showAlert = useAlert();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    const payload = { email, password, rememberMe };
    const result = await dispatch(loginUser(payload) as any);

    if (result && result.success) {
      showAlert(
        "success",
        "Benvenuto!",
        "Login effettuato con successo",
        "top-end",
        3000
      );
      setTimeout(() => {
        navigate("/home");
      }, 1000);
    } else {
      showAlert(
        "danger",
        "Errore di login",
        result.errorDescription || "Credenziali non valide!",
        "top-end",
        3000
      );
    }
  };

  return (
    <>
      <Container className="container-login-page d-flex align-items-center justify-content-center">
        <div className="login-form-container shadow p-4 bg-white">
          <h2 className="mb-4 titolo-login">Login</h2>
          <Form onSubmit={handleLogin}>
            <Form.Group controlId="email">
              <Form.Label>Email</Form.Label>
              <InputText
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                className="w-100 input"
                placeholder="Inserisci email"
              />
            </Form.Group>

            <Form.Group controlId="password" className="mt-3">
              <Form.Label>Password</Form.Label>
              <Password
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-100"
                inputStyle={{
                  width: "100%",
                  display: "block",
                  height: "46px",
                  borderRadius: "8px",
                }}
                style={{
                  width: "100%",
                  display: "block",
                  height: "46px",
                  borderRadius: "8px",
                }}
                toggleMask
                feedback={false}
                placeholder="Inserisci password"
              />
            </Form.Group>

            <Row className="align-items-center mt-3">
              <Col xs={6}>
                <div className="d-flex align-items-center">
                  <Checkbox
                    inputId="rememberMe"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.checked!)}
                  />
                  <label htmlFor="rememberMe" className="ms-2">
                    Ricordami
                  </label>
                </div>
              </Col>
              <Col xs={6} className="text-end">
                <div
                  className="forgot-password-link"
                  onClick={(e) => {
                    e.preventDefault();
                    setShowPasswordModal(true);
                  }}
                  style={{ cursor: "pointer" }}
                >
                  Password dimenticata?
                </div>
              </Col>
            </Row>

            <Button
              variant="primary"
              type="submit"
              className="w-100 mt-4"
              style={{ backgroundColor: "#F15A22", borderColor: "#F15A22" }}
            >
              Login
            </Button>
          </Form>
        </div>
      </Container>

      <PasswordDimenticata
        show={showPasswordModal}
        onClose={() => setShowPasswordModal(false)}
      />
    </>
  );
};

export default LoginPage;
